export default __webpack_public_path__ + "static/media/668.05ff5fe9.gif";